var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Premios"}},[_c('ul',_vm._l((_vm.items),function(item){return _c('li',[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":item.image}})]),_c('div',{staticClass:"content"},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(item.text))]),_c('p',{staticClass:"text"},[_vm._v(_vm._s(item.award))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }